<template>
    <s-dialog v-show="isShow" :dialog="dialogDescription">
        <section class="contentDescription" slot="content">
            <s-carousel @changeItem="changeItem" ref="carousel" class='switch' :carousel="carouselDescription">
                <div slot="switchComponent" class="clickElement">
                    <span class="left" @click="prev"></span>
                    <span class="right" @click="next"></span>
                </div>
            </s-carousel>
            <p>{{ carouselDescription['contentText'] }}</p>
        </section>

        <footer slot="footer">
            <el-button class="cancelBtn" @click="handleEvent(false)">{{ dialogDescription.cancel['text'] }}</el-button>
            <el-button class="confirmBtn" type="primary" @click="handleEvent(false)">{{ dialogDescription.confirm['text'] }}</el-button>
        </footer>
    </s-dialog>
</template>

<script>
import Vue from "vue";
import sDialog from '@/code-lab/view/organization/s-dialog.vue';
import sCarousel from '@/code-lab/view/organization/s-carousel.vue';
const $t = Vue.prototype.$t;
export default {
    name: 'connect-description-index',
    components: { sDialog, sCarousel },
    data(){
        return {
            carouselStatus: 0,
            isShow: false,
            dialogDescription: {
                isShow: false,
                title: $t( "code-lab/component/connection/quick/quick-cnnection.vue_0" ),
                cancel: { text: $t( "code-lab/component/connection/quick/quick-cnnection.vue_1" ) },
                confirm: { text: $t( "code-lab/component/connection/quick/quick-cnnection.vue_2" ) },
                closeOnEscape: false,
                closeOnModal: false,
                showClose: false,
                class: "connectStatusDialog connect-status connect-description-index",
                isFooter: true,
                width: "600px",
                appendToBody: true
            },
            carouselDescription: {
                autoplay: false,
                images: [
                "" + process.env.BASE_URL + "static/images/connect/image-step-1.png",
                "" + process.env.BASE_URL + "static/images/connect/image-step-2.png"
                
                ],
                contentText: ""
            },
            stateMachieDescription: {
                0: {
                todo: {
                    contentText: $t( "code-lab/component/connection/quick/quick-cnnection.vue_3" )
                }
                },
                1: {
                todo: {
                    contentText: $t( "code-lab/component/connection/quick/quick-cnnection.vue_4" )
                }
                }
            },
            stateMachineStatus: {
                empty: { to: {} },
                filled: { to: {} },
                success: { to: { isFooter: false, title: $t( "code-lab/component/connection/quick/quick-cnnection.vue_5" ) } },
                failed: {
                    to: {
                        isFooter: true,
                        title: $t( "code-lab/component/connection/quick/quick-cnnection.vue_6" ),
                        cancel: { text: $t( "code-lab/component/connection/quick/quick-cnnection.vue_7" ) },
                        confirm: { text: $t( "code-lab/component/connection/quick/quick-cnnection.vue_8" ) },
                        textAreaText:
                        $t( "code-lab/component/connection/quick/quick-cnnection.vue_9" )
                    }
                }
            }
        }
    },
    watch: {
        carouselStatus: {
            immediate: true,
            handler (newValue) {
                this.l$('immediate')
                const statusContent = this.stateMachieDescription[newValue].todo
                this.updateData(this.carouselDescription, statusContent)
            }
        }
    },
    methods: {
        updateData (key, value) {
            Object.assign(key, value)
        },
        handleEvent (isShow) {
            this.updateData(this, { isShow })
            this.updateData(this.dialogDescription, { isShow })
        },
        changeItem (index) {
            this.updateData(this, { carouselStatus: index })
        },
        next () {
            this.$refs.carousel.next()
        },
        prev () {
            this.$refs.carousel.prev()
        }
    }
}
</script>

<style lang="scss">
.connect-description-index {
    footer {
        .confirmBtn {
            background-color: $--codelab-primary-blue-2;
            color: #ffffff;
        }
    }

    .el-carousel {
        overflow: hidden;
        border-radius: 20px;
        position: static;
    }
    .el-carousel__container {
        height: 240px;
    }
    .el-dialog--center .el-dialog__body {
        padding: 28px 50px 30px 50px!important;
    }
    .switch {
        position: relative;
        border: solid 3px $--codelab-primary-blue-2;
        border-radius: 24px;
        img {
            width: 100%;
            height: 101%;
            object-fit: cover;
        }
    }

    .clickElement {
        span {
            width: 42px;
            height: 42px;
            border: solid 2px $--codelab-primary-blue-1;
            background-color: #239ab4;
            border-radius: 20px;
            position: relative;
            transition: .2s;
            &:active {
                opacity: .5;
            }
            &:hover {
                border-color: rgba(14, 211, 255, .5);
            }
        }
        .left {
            float: left;
            margin-left: -24px;
            &::before {
                display: inline-block;
                content: " ";
                height: 12px;
                width: 12px;
                border-width: 3px 3px 0px 0px;
                border-color: #000000;
                border-style: solid;
                -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
                transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
                position: absolute;
                -webkit-transform: rotate(-135deg);
                transform: rotate(-135deg);
                top: 48%;
                right: 13px;
                margin-top: -6px;
            }
        }
        .right {
            float: right;
            margin-right: -24px;
            &::before {
                display: inline-block;
                content: " ";
                height: 12px;
                width: 12px;
                border-width: 3px 3px 0px 0px;
                border-color: #000000;
                border-style: solid;
                -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
                transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
                position: absolute;
                -webkit-transform: rotate(-45deg);
                transform: rotate(45deg);
                top: 48%;
                right: 14px;
                margin-top: -6px;
            }
        }
        position: absolute;
        top: 102px;
        width: 100%;
        z-index: 2;
    }
    .el-carousel__item.is-animating {
        transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;
    }
    .el-carousel__indicators {
        display: flex;
        bottom: -45px;
        left: 50%;
        .el-carousel__indicator {
            cursor: default;
            background-color: transparent;
            margin-right: 10px;
            &:last-child {
               margin-right: 0px; 
            }
            .el-carousel__button {
                cursor: default;
                width: 8px;
                height: 8px;
                background-color: #c8c8c8;
                border-radius: 10px;
            }
        }
    }
    .contentDescription {
        p {
            width: 500px;
            margin: 0 auto;
            margin-top: 65px;
            text-align: center;
            letter-spacing: 1px;
            text-align: center;
            color: #ffffff;
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 20px;
            line-height: 25px;
        }
    }
}
</style>
